export const isBasketItemExpired = (
  item: { expireAt?: string | null } | null | undefined,
  now = Date.now()
): boolean => !!item?.expireAt && now > Date.parse(item.expireAt);
